/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleSetNextExecutionRequest {
    getFixupPrototypeFunction() { return ScheduleSetNextExecutionRequest.fixupPrototype; }

    static newInstance(model: Partial<ScheduleSetNextExecutionRequest>): ScheduleSetNextExecutionRequest {
        let obj = Object.assign(new ScheduleSetNextExecutionRequest(), model);
        ScheduleSetNextExecutionRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleSetNextExecutionRequest>): ScheduleSetNextExecutionRequest {
        if (!model) return null;
        return ScheduleSetNextExecutionRequest.newInstance(<ScheduleSetNextExecutionRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleSetNextExecutionRequest) {
        if (!obj) return;

        models.ScheduleSetNextExecutionRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleSetNextExecutionRequest): boolean {
        Object.setPrototypeOf(obj, ScheduleSetNextExecutionRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.next_run === "string") {
            this.next_run = new Date(<string><any>this.next_run);
        }
    }

    /**
     * When the next run of schedule to be triggered
     */
    next_run: Date;

}
